<template>
  <div class="certificaiton_table_list">
    <div class="tit">
      <span>统计汇报</span>
    </div>
    <div class="body_content" v-if="info">
      <div style="text-align:right;"  v-if="info.role ==='UserRoleEnterprise'">
        <el-select
          v-model="form.status"
          placeholder="状态筛选"
          style="width:200px;margin-left:20px;"
          @change="search"
        >
          <el-option label="全部填报状态" value></el-option>
          <el-option label="未提交" value="50"></el-option>
          <el-option label="已提交" value="10"></el-option>
          <el-option label="已撤回" value="40"></el-option>
        </el-select>
      </div>
      <!-- 企业身份 -->
      <div v-if="info.role ==='UserRoleEnterprise'">
        <el-table :data="tableData" border style="width: 100%;margin-top:20px;">
          <el-table-column fixed prop="name" label="统计项目名称"></el-table-column>
          <el-table-column prop="type_name" label="统计类型" width="120"></el-table-column>
          <el-table-column prop="create_date" label="发布时间" width="140"></el-table-column>
          <el-table-column prop="end_date" label="填报截止时间"  width="140"></el-table-column>
          <el-table-column prop="submit_date" label="提交时间" width="140"></el-table-column>
          <el-table-column prop="status_name" label="填报状态" width="80"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <!-- 未提交|| 已撤回 -->
              <div class="center" v-if="scope.row.status===50 || scope.row.status=== 40">
                <div>
                  <div class="blue_btn" @click="backEdit(scope.row)">编辑</div>
                </div>
              </div>
              <!-- 已提交 -->
              <div class="center" v-else-if="scope.row.status===10">
                <div>
                  <div class="blue_btn" @click="detail(scope.row)">查看详情</div>
                </div>
                <div>
                  <div class="blue_btn" @click="withdrawAuthenticateDialog(scope.row)">撤回</div>
                </div>
              </div>
              <!-- 已退回 -->
              <div class="center" v-else-if="scope.row.status===30">
                <div>
                  <div class="blue_btn" @click="viewOpinions(scope.row)">查看意见</div>
                </div>
                <div>
                  <div class="blue_btn" @click="detail(scope.row)">查看详情</div>
                </div>
                <div>
                  <div class="blue_btn" @click="backEdit(scope.row)">编辑</div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
        </div>
      </div>
      <!-- 普通身份 -->
      <div v-else-if="info.role ==='UserRoleOrdinary'">
        <el-button type="primary" @click="go('enterprise_certification_from')">去认证</el-button>
      </div>
      <!-- 员工身份 -->
      <div v-else-if="info.role ==='UserRoleEmployee'">已拥有员工身份</div>
    </div>
    <!-- 意见 -->
    <el-dialog title="查看意见" :visible.sync="dialogVisible" width="600px" center>
      <span v-if="row && row.examine_remark" v-cloak>{{row.examine_remark}}</span>
      <span v-else>暂无</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import myPage from "@/components/myPage/myPage";
export default {
  components: {
    myPage
  },
  data() {
    return {
      form: { status: "" },
      tableSwitch: 0, //模块展示判断 1:企业 2：普通 3：员工
      tableData: [],
      layerpageinfo: {
        pageNo: 0,
        total: 0,
        pageSize: 10
      },
      row: null, //临时操作行
      searchData: {},
      dialogVisible:false
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  created() {
    this.getStatisticByEnterprise();
  },
  methods: {
    search() {
      this.layerpageinfo = {
        pageNo: 0,
        total: 0,
        pageSize: 10
      };
      this.getStatisticByEnterprise();
    },
    /** 企业查询填报状态*/
    getStatisticByEnterprise() {
      let params = Object.assign({}, this.layerpageinfo, this.form);
      this.api.getStatisticByEnterprise(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.tableData = res.obj.list || [];
        this.layerpageinfo.total = res.obj.totalSize;
      });
    },
    /*页面跳转*/

    go(name) {
      this.$router.push({
        name: name
      });
    },
    /*改变分页*/

    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getStatisticByEnterprise();
    },
    /*返回修改 编辑*/
    backEdit(item) {
      // 季度统计 || 在孵企业情况
      let name =
        item.type === "StatisticTypeQuarter"
          ? "enterprise_statistical_from"
          : "enterprise_statistical_enterprise_from";
      // name = 'enterprise_statistical_enterprise_from'
      this.$router.push({
        name: name,
        query: {
          id: item.id
        }
      });
      sessionStorage.setItem('statisticyear',item.id)
    },
    /*查看详情*/

    detail(item) {
      let name =
        item.type === "StatisticTypeQuarter"
          ? "enterprise_statistical_details"
          : "enterprise_statistical_enterprise_details";
      this.$router.push({
        name: name,
        query: {
          id: item.id
        }
      });
    },
    /* 撤回机构认证弹窗*/
    withdrawAuthenticateDialog(row) {
      this.$confirm("确定撤回?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.withdrawAuthenticate(row);
        })
        .catch(() => {});
    },
    /* 撤回机构认证 */
    withdrawAuthenticate(row) {
      this.api
        .approvalEnterpriseStatistic({
          id: row.enterprise_statistic,
          operation: 40
        })
        .then(res => {
          if (res.error.err_code !== 0) return;
          this.$message({
            type: "success",
            message: "撤回成功!"
          });
          this.getStatisticByEnterprise(); //列表
        });
    },
    /* 查看意见 */
    viewOpinions(row) {
      this.dialogVisible = true;
      this.row = row;
    }
  }
};
</script>

<style lang="scss" scoped>
.blue_btn {
  color: $font-blue;
  cursor: pointer;
}
</style>